import { __assign, __spreadArrays } from "tslib";
import React, { useReducer, useRef } from 'react';
import InternalBreadcrumbGroup from '../../breadcrumb-group/internal';
import { InternalButton } from '../../button/internal';
import InternalModal from '../../modal/internal';
import InternalSpaceBetween from '../../space-between/internal';
import { useEffectOnUpdate } from '../../internal/hooks/use-effect-on-update';
import { BucketsTable } from './buckets-table';
import { ObjectsTable } from './objects-table';
import { VersionsTable } from './versions-table';
import styles from './styles.css.js';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function assertNever(_value) {
    return null;
}
var initialBrowseState = {
    selectedItem: null,
    currentView: 'buckets',
    breadcrumbs: []
};
function s3BrowseReducer(state, action) {
    switch (action.type) {
        case 'browse-buckets':
            return initialBrowseState;
        case 'browse-objects':
            return {
                selectedItem: null,
                currentView: 'objects',
                breadcrumbs: action.breadcrumbs
            };
        case 'browse-versions':
            return {
                selectedItem: null,
                currentView: 'versions',
                breadcrumbs: action.breadcrumbs
            };
        case 'select-item':
            return __assign(__assign({}, state), { selectedItem: action.item });
        default:
            assertNever(action);
    }
    return state;
}
function createResourceInfo(_a) {
    var currentView = _a.currentView, breadcrumbs = _a.breadcrumbs, selectedItem = _a.selectedItem;
    var prefix = 's3://';
    if (currentView === 'versions') {
        return { uri: prefix + breadcrumbs.join('/'), versionId: selectedItem !== null && selectedItem !== void 0 ? selectedItem : undefined };
    }
    return { uri: prefix + __spreadArrays(breadcrumbs, [selectedItem]).join('/') };
}
export function S3Modal(_a) {
    var _b;
    var i18nStrings = _a.i18nStrings, alert = _a.alert, selectableItemsTypes = _a.selectableItemsTypes, fetchBuckets = _a.fetchBuckets, bucketsVisibleColumns = _a.bucketsVisibleColumns, bucketsIsItemDisabled = _a.bucketsIsItemDisabled, fetchObjects = _a.fetchObjects, objectsVisibleColumns = _a.objectsVisibleColumns, objectsIsItemDisabled = _a.objectsIsItemDisabled, fetchVersions = _a.fetchVersions, versionsVisibleColumns = _a.versionsVisibleColumns, versionsIsItemDisabled = _a.versionsIsItemDisabled, onSubmit = _a.onSubmit, onDismiss = _a.onDismiss;
    var _c = useReducer(s3BrowseReducer, initialBrowseState), _d = _c[0], currentView = _d.currentView, breadcrumbs = _d.breadcrumbs, selectedItem = _d.selectedItem, dispatch = _c[1];
    var forwardFocusRef = useRef(null);
    useEffectOnUpdate(function () {
        var _a;
        (_a = forwardFocusRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [breadcrumbs]);
    return (React.createElement(InternalModal, { visible: true, size: "max", closeAriaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.labelModalDismiss, onDismiss: onDismiss, header: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.modalTitle, footer: React.createElement(InternalSpaceBetween, { className: styles['modal-actions'], size: "xs", direction: "horizontal" },
            React.createElement(InternalButton, { variant: "link", formAction: "none", onClick: onDismiss }, i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.modalCancelButton),
            React.createElement(InternalButton, { variant: "primary", className: styles['submit-button'], disabled: !selectedItem, formAction: "none", onClick: function () { return onSubmit(createResourceInfo({ currentView: currentView, breadcrumbs: breadcrumbs, selectedItem: selectedItem })); } }, i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.modalSubmitButton)) },
        React.createElement(InternalSpaceBetween, { size: "xs" },
            React.createElement(InternalBreadcrumbGroup, { ariaLabel: i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.labelBreadcrumbs, onFollow: function (event) {
                    event.preventDefault();
                    event.detail.item.meta.onClick();
                }, items: __spreadArrays([
                    {
                        text: (_b = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.modalBreadcrumbRootItem) !== null && _b !== void 0 ? _b : '',
                        href: '',
                        meta: { onClick: function () { return dispatch({ type: 'browse-buckets' }); } }
                    }
                ], breadcrumbs.map(function (segment, index) { return ({
                    text: segment,
                    href: '',
                    meta: {
                        onClick: function () {
                            return dispatch({
                                type: 'browse-objects',
                                breadcrumbs: breadcrumbs.slice(0, index + 1)
                            });
                        }
                    }
                }); })) }),
            alert,
            currentView === 'buckets' ? (React.createElement(BucketsTable, { forwardFocusRef: forwardFocusRef, fetchData: fetchBuckets, visibleColumns: bucketsVisibleColumns, isItemDisabled: bucketsIsItemDisabled, selectableItemsTypes: selectableItemsTypes, i18nStrings: i18nStrings, onDrilldown: function (path) {
                    return dispatch({
                        type: 'browse-objects',
                        breadcrumbs: [path]
                    });
                }, onSelect: function (item) { return dispatch({ type: 'select-item', item: item }); } })) : currentView === 'objects' ? (React.createElement(ObjectsTable, { forwardFocusRef: forwardFocusRef, pathSegments: breadcrumbs, fetchData: fetchObjects, visibleColumns: objectsVisibleColumns, isItemDisabled: objectsIsItemDisabled, selectableItemsTypes: selectableItemsTypes, i18nStrings: i18nStrings, onDrilldown: function (item) {
                    dispatch({
                        type: item.IsFolder ? 'browse-objects' : 'browse-versions',
                        breadcrumbs: __spreadArrays(breadcrumbs, [item.Key])
                    });
                }, onSelect: function (item) { return dispatch({ type: 'select-item', item: item }); } })) : currentView === 'versions' ? (React.createElement(VersionsTable, { forwardFocusRef: forwardFocusRef, pathSegments: breadcrumbs, fetchData: fetchVersions, visibleColumns: versionsVisibleColumns, isItemDisabled: versionsIsItemDisabled, i18nStrings: i18nStrings, onSelect: function (item) { return dispatch({ type: 'select-item', item: item }); } })) : (assertNever(currentView)))));
}
//# sourceMappingURL=index.js.map